import { Descendant, Editor } from 'slate';
import { getQueryOptions, WithQueryOptions } from '../utils/match';

export function getNext<T extends Descendant>(editor: Editor, options?: WithQueryOptions<typeof Editor.next, 1>) {
    return Editor.next<T>(editor, getQueryOptions(editor, options));
}
